const LIVE_BACTERIA = "LiveBacteria";

const IMAGE_URLS = {
  "hatchways/team-blueberry":
    "https://raw.githubusercontent.com/hatchways/team-blueberry/dev/client/public/thumbnail.png",
  "livebacteria/magic-researcher-game":
    "https://raw.githubusercontent.com/LiveBacteria/magic-researcher-game/master/MagicGame-Home.png",
};

const DISPLAY_NAME_MAP = {
  "hatchways/team-blueberry": "peer-code-review",
};

const getImageForRepo = (repo) => {
  const fullName = repo.full_name?.toLowerCase() || "";
  return IMAGE_URLS[fullName] || null;
};

const normalizeRepo = (repo) => {
  const fullName = repo.full_name?.toLowerCase() || "";

  return {
    id: repo.id,
    name: repo.name,
    displayName: DISPLAY_NAME_MAP[fullName] || repo.name,
    full_name: repo.full_name,
    html_url: repo.html_url,
    description: repo.description || "No description provided.",
    imageURL: getImageForRepo(repo),
    language: repo.language || "Unknown",
    stargazers_count: repo.stargazers_count || 0,
    forks_count: repo.forks_count || 0,
    updated_at: repo.updated_at,
  };
};

const fetchJson = async (url) => {
  const response = await fetch(url, {
    headers: {
      Accept: "application/vnd.github+json",
    },
  });

  if (!response.ok) {
    throw new Error(`GitHub API request failed: ${response.status}`);
  }

  return response.json();
};

const selectRepos = (allRepos, teamBlueberry) => {
  const liveBacteriaRepos = allRepos.filter(
    (repo) => repo.owner?.login?.toLowerCase() === LIVE_BACTERIA.toLowerCase()
  );

  const hasTeamBlueberry = liveBacteriaRepos.some(
    (repo) => repo.full_name?.toLowerCase() === "hatchways/team-blueberry"
  );

  const mergedRepos = hasTeamBlueberry || !teamBlueberry
    ? liveBacteriaRepos
    : [...liveBacteriaRepos, teamBlueberry];

  return mergedRepos
    .map(normalizeRepo)
    .sort((a, b) => new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime());
};

const getRepos = async () => {
  const [starredRepos, teamBlueberry] = await Promise.all([
    fetchJson(`https://api.github.com/users/${LIVE_BACTERIA}/starred?per_page=100&sort=updated`),
    fetchJson("https://api.github.com/repos/hatchways/team-blueberry").catch(() => null),
  ]);

  return selectRepos(starredRepos, teamBlueberry);
};

export { getRepos };
